import { Label, Span, Input, P } from 'alkali'
import './Toggle.scss'

export const Toggle = Label.with('.toggle', {
	created(properties) {
		this.append(
			new Label('toggle', [
				Input(
					'.toggle-input',
					{
						id: properties.id,
						type: 'checkbox',
						checked: properties.checked,
						name: properties.name,
						onchange: properties?.oncheckboxchanged
					},
				),
				P('.toggle-round')
			])
		)
	},
})
